import * as t from "io-ts";

export const LocationMetaPossibleDestinationCodec = t.intersection([
  t.type({
    siteId: t.string,
    siteName: t.string,
  }),
  t.partial({
    latitude: t.number,
    longitude: t.number,
    confidence: t.number,
    etaDttm: t.number,
    distance: t.number,
    status: t.string,
  }),
]);

export const LocationMetaPossibleDestinationArrayCodec = t.array(
  LocationMetaPossibleDestinationCodec
);

export type LocationMetaPossibleDestination = t.TypeOf<typeof LocationMetaPossibleDestinationCodec>;
